/*=========================================================================================
  File Name: router.js
  Description: Routes for vue-router. Lazy loading is enabled.
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import Vue from "vue";
import Router from "vue-router";
import store from "./store/store"

Vue.use(Router);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  routes: [
    {
      // =============================================================================
      // MAIN LAYOUT ROUTES
      // =============================================================================
      path: "",
      component: () => import("./layouts/main/Main.vue"),
      children: [
        // =============================================================================
        // Theme Routes
        // =============================================================================
        {
          path: "/",
          name: "orders",
          component: () => import("./views/Orders.vue")
        },
        {
          path: "/orders",
          name: "orders",
          component: () => import("./views/Orders.vue")
        },
        {
          path: "/sent-orders",
          name: "sent-orders",
          component: () => import("./views/SentOrders.vue")
        },
        {
          path: "/errors",
          name: "errors",
          component: () => import("./views/Errors.vue")
        },
        {
          path: "/contact-forms",
          name: "contact-forms",
          component: () => import("./views/ContactForms.vue")
        },
        {
          path: "/delivery-time",
          name: "delivery-time",
          component: () => import("./views/DeliveryTime.vue")
        },
        {
          path: "/analysis",
          name: "analysis",
          component: () => import("./views/Analysis.vue"),
          meta: { requiredRole: "superadmin" }
        },
        {
          path: "/prices",
          name: "prices",
          component: () => import("./views/PriceManagement.vue"),
          meta: { requiredRole: "superadmin" }
        }
      ]
    },
    // =============================================================================
    // FULL PAGE LAYOUTS
    // =============================================================================
    {
      path: "",
      component: () => import("@/layouts/full-page/FullPage.vue"),
      children: [
        // =============================================================================
        // PAGES
        // =============================================================================
        {
          path: "/pages/login",
          name: "page-login",
          component: () => import("@/views/pages/Login.vue")
        },
        {
          path: "/pages/error-404",
          name: "page-error-404",
          component: () => import("@/views/pages/Error404.vue")
        }
      ]
    },
    // Redirect to 404 page, if no match found
    {
      path: "*",
      redirect: "/pages/error-404"
    }
  ]
});

router.beforeEach((to, from, next) => {
      console.log("routing to: ", to);
      if (to.name !== 'page-login') {
        console.log(store.state.auth.token);
      if (!store.state.auth.token) {
          next({
              name: 'page-login',
          })
        } else if (to.meta.requiredRole) {
          const role = store.getters["auth/userRole"];
          if (role !== to.meta.requiredRole) {
            next({ name: 'orders' })
          } else {
            next()
          }
        } else {
          next()
        }
      } else {
          next()
      }

}) 

router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById("loading-bg");
  if (appLoading) {
    appLoading.style.display = "none";
  }
});

export default router;
